import React, { Component, useEffect, useState, useRef, createRef, store } from 'react'
import { useIonAlert } from '@ionic/react';
import { useLocation } from 'react-router'
import {
    Grid,
    Typography,
    Drawer,
    Toolbar,
    Divider,
    Box,
    Stack,
    CssBaseline,
    List,
    ListItem,
    Avatar
} from '@mui/material'
import * as Loaders from '../../components/UIComponents/Loader'
import * as Alerts from '../../components/UIComponents/Alert'
import * as Icons from '../../components/UIComponents/Icons'
import * as Buttons from '../../components/UIComponents/Button'
import * as IconButtons from '../../components/UIComponents/IconButtons'
import * as Texts from '../../components/UIComponents/Text'
import * as Images from '../../components/UIComponents/Images'
import * as Forms from '../../components/UIComponents/Form'
import AppNavigator2 from '../../components/AppNavigator2'
import DotIndicator from './DotIndicator'
import MustAsterik from './MustAsterik'
import moment from 'moment'
import config from '../../config/config'
import KeyValuePairs from './KeyValuePairComponent'
import LeftProgressPanel from './LeftProgressPanel'
import BotHelper from '../../helpers/BotHelper'
import CircularProgress from '@mui/material/CircularProgress';
import { v4 as uuidv4 } from 'uuid'



const HealthData = ({
    children,
    history,
    bot,//botProfile
    updateBotProfileBulk,
    updateBotProfile,
    selectedDot,
    setSelectedDot,
    handleSubmitSurvey,
    handleRedirectToBot,
    dict,
    resetSession
}) => {
    const elementRef = useRef()
    const [error, setError] = useState({})
    // const [symptomsAndBehaviours, updateSymptomsAndBehaviours] = useState([])
    const [symptomsAndBehavioursObj, setSymptomsAndBehavioursObj] = useState([])
    const prevSymptomsAndBehavioursDataRef = useRef(null)    

    // const [responseStyle, updateResponseStyle] = useState([])
    const [responseStyleObj, setResponseStyleObj] = useState([])
    const prevResponseStyleDataRef = useRef(null)

    const [surveySubmitting, updateSurveySubmitting] = useState(false)
    const [surveySubmitted, updateSurveySubmitted] = useState(false)
    const [surveyErrored, updateSurveyErrored] = useState(false)
    const [presentAlert] = useIonAlert()

    // this locks the useEffect so it only gets fired when users are in this page
    const location = useLocation();
    const isActive = location.pathname === '/profilesetup/health-data';


    function isValidData() {
        const errors = {}
        const symptomsAndBehaviours = symptomsAndBehavioursObj
        if (symptomsAndBehaviours.some(val => {
            return typeof val === 'object' && (
                (val.type === undefined || val.type.trim() === '') ||
                (val.detail === undefined || val.detail.trim() === '')
            )
        })) {
            errors.symptomsAndBehaviours = dict["symptomsAndBehavioursIncompleteError"]
        }

        const responseStyle = responseStyleObj
        if (responseStyle.some(val => {
            return typeof val === 'object' && (
                (val.type === undefined || val.type.trim() === '') ||
                (val.detail === undefined || val.detail.trim() === '')
            )
        })) {
            errors.responseStyle = dict["responseStyleIncompleteError"]
        }

        // console.log("errors: ", errors)
        setError(errors)
        return errors
    }


    function showFirstError(errors) {
        const firstErrorField = Object.keys(errors)[0];
        if (firstErrorField) {
            presentAlert({
                header: dict["alertTitle"],
                message: errors[firstErrorField],
                buttons: ["OK"]
            })
        }
    }

    function isValidDataUserProfile() {
        const errors = []
        let isError = false
    
        const fields = ["userNickname", "botNickname", "userGender", "relation", "userOccupation"];

        fields.forEach((field) => {
            if (!bot["profileObj"] || !bot["profileObj"]["longMem"] || !bot["profileObj"]["longMem"].hasOwnProperty(field) || bot["profileObj"]["longMem"][field] === "") {
                isError = true
            }
        })

        let birthdate = bot["profileObj"]?.["longMem"]?.["userBirthdate"] || ""
        if (!birthdate || typeof birthdate !== "string") {
            birthdate = String(birthdate);
        }
        if (!/^\d{8}$/.test(birthdate)) {
            isError = true
        } else {
            const year = parseInt(birthdate.slice(0, 4), 10);
            const month = parseInt(birthdate.slice(4, 6), 10) - 1;
            const day = parseInt(birthdate.slice(6, 8), 10);
            const date = new Date(year, month, day);
    
            if (
                date.getFullYear() !== year ||
                date.getMonth() !== month ||
                date.getDate() !== day
            ) {
                isError = true
            }
        }
        if(isError == true){
            errors.push(dict["OtherPageValidationError"]
                // .replace("{pageNumber}", 1)
                .replace("{pageName}", "ユーザー情報")
            )
        }
        return errors
    }
    
    
    function isValidDemographicProfile() {
        const errors = [];
        let isError = false;
    
        const profileFields = ["name", "age", "gender"];
        profileFields.forEach((field) => {
            if (!bot?.profileObj?.[field] || bot.profileObj[field] === "" || bot.profileObj[field] === 0) {
                isError = true;
            }
        });
    
        const deathReason = bot?.profileObj?.longMem?.deathReason || "";
        const otherReason = bot?.profileObj?.longMem?.otherReason || "";
    
        if (!deathReason) {
            isError = true;
        }
        if (deathReason === "Other" && !otherReason) {
            isError = true;
        }
    
        if (isError) {
            errors.push(dict["OtherPageValidationError"]
                // .replace("{pageNumber}", 2)
                .replace("{pageName}", "大切な人の個人情報")
            );
        }
    
        return errors;
    }
    

    function isValidateLifeDetails() {
        const errors = []
        let isError = false
        
    
        const story = bot?.profileObj?.storyObj || {};
        if (!story || Object.keys(story).length === 0) {
            isError = true;
        } else if (
            
            Object.values(story).some(val => {
                // console.log("Object.values(story).some", Object.values(story))
                return typeof val === "object" && val !== null && (
                    (val.type === null || val.type === undefined || (typeof val.type === 'string' && val.type.trim() === "")) ||
                    (val.detail === null || val.detail === undefined || (typeof val.detail === 'string' && val.detail.trim() === ""))
                )
            })
        ) {
            isError = true;
        }

        const background = bot?.profileObj?.backgroundObj || {};
        // console.log("background", background)
        if (!background || Object.keys(background).length === 0) {
            console.log("the background is not filled ", background)
            isError = true;
        } else if (
            Object.values(background).some(val => {
                return typeof val === "object" && val !== null && (
                    (val.type === null || val.type === undefined || (typeof val.type === 'string' && val.type.trim() === "")) ||
                    (val.detail === null || val.detail === undefined || (typeof val.detail === 'string' && val.detail.trim() === ""))

                )
            })
        ) {
            console.log("some of the values in the background aren't filled")
            isError = true;
        }

        // const personality = bot?.profileObj?.personalityObj || {};
        // if (!personality || Object.keys(personality).length === 0) {
        //     isError = true;
        //     console.log("p error ")
        // } else if (
        //     Object.values(personality).some(val => {
        //         return typeof val === "object" && val !== null && (
        //             (val.type === null || val.type === undefined || (typeof val.type === 'string' && val.type.trim() === "")) ||
        //             (val.detail === null || val.detail === undefined || (typeof val.detail === 'string' && val.detail.trim() === ""))
        //         )
        //     })
        // ) {
        //     isError = true;console.log("p2 error ")
        // }
        

        if (isError) {
            errors.push(dict["OtherPageValidationError"]
                // .replace("{pageNumber}", 3)
                .replace("{pageName}", "生活の具体像")
            );
        }
        
        return errors;
    }
    

    function showFirstErrorWithRedirect(errors, redirectInfo) {
        const firstErrorField = Object.keys(errors)[0];
        if (firstErrorField) {
            presentAlert({
                header: dict["alertTitle"],
                message: errors[firstErrorField],
                buttons: [
                    {
                        text: dict["cancelText"],
                        role: "cancel"
                    },
                    {
                        text: dict["yesText"],
                        handler: () => {
                            setSelectedDot(redirectInfo.dotIndex);
                            history.push(redirectInfo.path, {errors});
                        }
                    }
                ]
            });
        }
    }
    
    
    useEffect(() => {
        if (!isActive) return;

        const processKeyValueData = (ymlString, setObjState, prevRef, existingObjArrFromRedux) => {
            let finalArray = []
            if (existingObjArrFromRedux && Array.isArray(existingObjArrFromRedux) && existingObjArrFromRedux.length > 0 && existingObjArrFromRedux[0].id) {
                finalArray = existingObjArrFromRedux.map(item => ({
                    id: item.id,
                    type: String(item.type || ''),
                    detail: String(item.detail || '')
                }))
            } else {
                let currentParsed = []
                try {
                    if (ymlString && typeof ymlString === 'string' && ymlString !== '0') {
                        let tempParsed = BotHelper.paresYmlString(ymlString);
                        if (Array.isArray(tempParsed) && tempParsed.length > 0) {
                            currentParsed = tempParsed.map(item => {
                                const type = (item && typeof item === 'object' && item.type) ? String(item.type) : ''
                                const detail = (item && typeof item === 'object' && item.detail) ? String(item.detail) : ''
                                return { type: type, detail: detail }
                            });
                        }
                    }
                } catch (e) {
                    // console.error("HealthData: Error parsing YML or processing data:", e)
                    currentParsed = []
                }

                if (currentParsed.length > 0) {
                    finalArray = currentParsed.map(item => ({
                        id: uuidv4(),
                        type: item.type,
                        detail: item.detail
                    }))
                } else {
                    finalArray = [{ id: uuidv4(), type: "", detail: "" }]
                }
            }
            
            const currentDataForComparison = finalArray.map(({ type, detail }) => ({ type, detail }))
            if (prevRef.current && JSON.stringify(prevRef.current) === JSON.stringify(currentDataForComparison)) {
                return false
            }

            setObjState(finalArray)
            prevRef.current = currentDataForComparison
            return true
        }

        processKeyValueData(
            bot?.profileObj?.symptomsAndBehaviours, 
            setSymptomsAndBehavioursObj, 
            prevSymptomsAndBehavioursDataRef,
            bot?.profileObj?.symptomsAndBehavioursObj
        )
        processKeyValueData(
            bot?.profileObj?.responseStyle,
            setResponseStyleObj,
            prevResponseStyleDataRef,
            bot?.profileObj?.responseStyleObj 
        )

    }, [
        isActive,
        bot?.profileObj?.symptomsAndBehaviours,
        bot?.profileObj?.symptomsAndBehavioursObj,
        bot?.profileObj?.responseStyle,
        bot?.profileObj?.responseStyleObj
        // bot
    ])

    return (<React.Fragment>
        <AppNavigator2
            title={dict["pageTitle"]}
            // sx={...your custom style}
            onBackClicked={() => {
                presentAlert({
                    header: dict["isBackToLoginTitle"],
                    message: dict["isBackToLoginMessage"],
                    buttons: [
                        {
                            text: dict["cancelText"],
                            role: "cancel"
                        },
                        {
                            text: dict["yesText"],
                            handler: () => {
                                // resetSession()
                                return history.push('/')
                            }
                        }
                    ]
                })
                return false
            }}

            onBackToChatRoomClicked={
                bot?.id && bot?.profileObj?.isEditProfile === true ?  () => { 
                    presentAlert({
                        header: dict["isBackToChatRoomTitle"],
                        message: dict["isBackToChatRoomMessage"],
                        buttons: [
                            {
                                text: dict["cancelText"],
                                role: "cancel"
                            },
                            {
                                text: dict["yesText"],
                                handler: () => {
                                    return history.push('/chatroom/pdfbot');
                                }
                            }
                        ]
                    });
                } : null
            }
        />
        <Grid container
            direction={{
                xs: "column",
                md: "row"
            }}
            sx={{
                flex: 1,
                bgcolor: 'background.gray',
                height: `calc(100vh - ${config.headerHeight}px)`,
                overflowY: {
                    xs: "scroll",
                    md: "hidden"
                }
            }}
        >
            {/** The left image and progress indicator */}
            <Grid item
                sx={{
                    flex: {
                        xs: .2,
                        sm: .2,
                        md: 1
                    },
                    height: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: {
                        sm: 'center',
                        md: "flex-start"
                    },
                    alignItems: "center"
                    // bgcolor: 'background.default'
                }}
            >
                {/*<Stack
                    direction={"column"}
                    justifyContent={{
                        xs: "center",
                        lg: "flex-start"
                    }}
                    alignItems={"center"}
                    spacing={4}
                    sx={{
                        // bgcolor: 'background.dark',
                        width: 1,
                        px: {
                            xs: 4,
                            sm: 6,
                            md: 8
                        },
                        py: {
                            xs: 4,
                            sm: 6,
                            md: 8
                        }
                    }}
                >
                    <Texts.H4
                        sx={{
                            color: 'primary.dark'
                        }}
                    >Avatar Profile Setup</Texts.H4>
                    <Texts.Tip>In this section, you will be guided through the profile setup steps. The whole process can take up to 10 minutes.</Texts.Tip>
                    <Box
                        sx={{
                            width: '240px',
                            display: {
                                xs: 'none',
                                md: 'block'
                            }
                        }}
                    >
                        <Images.HealthData />
                    </Box>
                    <DotIndicator selectedDot={selectedDot} setSelectedDot={setSelectedDot} />
                </Stack>*/}
                {/*<LeftProgressPanel history={history} selectedDot={selectedDot} setSelectedDot={setSelectedDot} />*/}
                {children}
            </Grid>
            <Grid item
                sx={{
                    flex: 1,
                    height: {
                        md: 1
                    },
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: "flex-start",
                    alignItems: "center",
                    bgcolor: 'background.default',
                    overflowY: {
                        xs: "scroll",
                        md: "scroll"
                    }
                }}
            >
                <Stack
                    spacing={2}
                    direction={"column"}
                    sx={{
                        width: 1,
                        px: {
                            xs: 4,
                            sm: 6,
                            md: 8
                        },
                        py: {
                            xs: 4,
                            sm: 6,
                            md: 8
                        }
                    }}
                >
                    <Box>
                        <Texts.Tip><MustAsterik />{`${dict["asterik"]}`}</Texts.Tip>
                    </Box>
                    {/* <Texts.H4
                        sx={{
                            mb: {
                                xs: 4,
                                md: 6
                            },
                            color: 'primary.dark'
                        }}
                    >{dict["sectionTitle"]}</Texts.H4> */}
                    {/* <Texts.Paragraph>
                        {dict["sectionExplain"]}
                    </Texts.Paragraph> */}
                    {/* <Divider /> */}
                    <Texts.H6>{dict["symptomsAndBehaviours"]}<MustAsterik /></Texts.H6>
                    <Texts.Paragraph>
                        {dict["symptomsAndBehavioursHelpingText"]}
                    </Texts.Paragraph>

                     <KeyValuePairs
                        targetTheme={dict["symptomsAndBehavioursTargetTheme"]}
                        maxArr={10}
                        inputJsonArr={symptomsAndBehavioursObj}
                        enableCustomType={true}
                        predefinedTypes={dict["symptomsAndBehavioursTypeOptions"]}
                        useAutocomplete={true}
                        typeLabel={dict["typeLabel"]}
                        detailLabel={dict["detailLabel"]}
                        maxWarning={dict["maxWarning"]}
                        deleteWarning={dict["deleteWarning"]}
                        cancelText={dict["cancelText"]}
                        yesText={dict["yesText"]}
                        onUpdateArr={(newArr) => {
                            updateBotProfileBulk({
                                profileObj: {
                                    symptomsAndBehaviours: BotHelper.convertJsonToYmlString(newArr),
                                    symptomsAndBehavioursObj: newArr
                                }
                            });
                        }}
                        // error={error}
                    />


                    <Texts.H6>{dict["response"]}<MustAsterik /></Texts.H6>
                    <Texts.Paragraph>
                        {dict["responseHelpingText"]}
                    </Texts.Paragraph>

                    <KeyValuePairs
                        targetTheme={dict["responseTargetTheme"]}
                        maxArr={10}
                        inputJsonArr={responseStyleObj}
                        enableCustomType={true}
                        predefinedTypes={dict["responseStyleTypeOptions"]}
                        useAutocomplete={true}
                        typeLabel={dict["typeLabel"]}
                        detailLabel={dict["detailLabel"]}
                        maxWarning={dict["maxWarning"]}
                        deleteWarning={dict["deleteWarning"]}
                        cancelText={dict["cancelText"]}
                        yesText={dict["yesText"]}
                        onUpdateArr={(newArr) => {
                            updateBotProfileBulk({
                                profileObj: {
                                    responseStyle: BotHelper.convertJsonToYmlString(newArr),
                                    responseStyleObj: newArr
                                }
                            });
                        }}
                    />
                    <Stack
                        spacing={4}
                        direction={"row"}
                        justifyContent={"space-between"}
                    >
                        <Buttons.SecondaryButton
                            onClick={() => {
                                history.push("/profilesetup/life-detail")
                                setSelectedDot(2)
                                // console.log(`the name is ${name}`)
                                // console.log(`the age is ${age}`)
                                // console.log(`the gender is ${gender}`)

                            }}
                        >
                            {dict["prev"]}
                        </Buttons.SecondaryButton>
                        {!surveySubmitted ?
                            !surveySubmitting ?
                                <Buttons.Button
                                    onClick={async () => {
                                        const errors = isValidData()
                                        const userProfileErrors = isValidDataUserProfile()
                                        const demographicProfileErrors = isValidDemographicProfile()
                                        const lifeDetailsErrors = isValidateLifeDetails()
                                        
                                        // if (Object.keys(errors).length > 0) {
                                        //     showFirstError(errors)
                                        // }
                                        if (Object.keys(userProfileErrors).length > 0) {
                                            showFirstErrorWithRedirect(userProfileErrors, {
                                                dotIndex: 0,
                                                path: "/profilesetup/user-profile"
                                            })
                                        } else if (Object.keys(demographicProfileErrors).length > 0) {
                                            showFirstErrorWithRedirect(demographicProfileErrors, {
                                                dotIndex: 1,
                                                path: "/profilesetup/demo-profile"
                                            })
                                        } else if (Object.keys(lifeDetailsErrors).length > 0) {
                                            showFirstErrorWithRedirect(lifeDetailsErrors, {
                                                dotIndex: 2,
                                                path: "/profilesetup/life-details"
                                            })
                                        }                                                                               
                                        else {
                                            
                                            try{
                                                await updateSurveySubmitting(true)
                                                console.log("longmem", bot?.profileObj?.longMem)
                                                // const longMemYml = BotHelper.convertObjectToLongMemYaml(bot?.profileObj?.longMem) || ""
                                                // console.log("converted longMem:", longMemYml)
                                                // save all the input in the state again, and then send the json object to the server
                                                await updateBotProfileBulk({
                                                    profileObj: {
                                                        // story: story,
                                                        // background: background,
                                                        // symptomsAndBehaviours: symptomsAndBehaviours,
                                                        // symptomsAndBehavioursObj: symptomsAndBehaviours,
                                                        // responseStyle: BotHelper.convertJsonToYmlString(responseStyle),
                                                        // responseStyleObj: responseStyle,
                                                        longMem: bot?.profileObj?.longMem
                                                    }
                                                })

                                                const updateResults = await handleSubmitSurvey()
                                                // console.log(updateResults)
                                                if (updateResults) {
                                                    updateSurveySubmitted(true)
                                                    updateSurveyErrored(false)
                                                    updateSurveySubmitting(false)
                                                    elementRef.current.scrollIntoView()
                                                    return handleRedirectToBot()
                                                }
                                                // use the upper level component to handle the submission
                                                updateSurveySubmitted(false)
                                                updateSurveyErrored(true)
                                                updateSurveySubmitting(false)
                                                elementRef.current.scrollIntoView()
                                                return
                                            }
                                            catch (error) {
                                                console.error("Error during submission:", error)
                                                updateSurveyErrored(true)
                                            } finally {
                                                updateSurveySubmitting(false)
                                            }
                                            
                                        }

                                    }}
                                    
                                >
                                    {dict["submit"]}
                                </Buttons.Button>
                                :
                                <Box>
                                    <Loaders.CircleLoader />
                                </Box>
                            : null}
                    </Stack>

                    {surveySubmitted && <Alerts.Success>
                        <Texts.Paragraph>{dict["submitSuccess"].replace(/\${botname}/g, bot["profileObj"]["name"]) .replace("${botgender}", bot["profileObj"]["gender"] === "Male" ? "him" : "her")
                            || `Congratulation. ${bot["profileObj"]["name"]} has been created. You can now start chatting with ${bot["profileObj"]["gender"] === "Male" ? "him" : "her"}. The page will be redirected in 5 seconds.`}</Texts.Paragraph>
                        <Loaders.CircleLoader />
                    </Alerts.Success>}
                    {surveyErrored && <Alerts.Error message={dict["submitError"].replace(/\${botname}/g, bot["profileObj"]["name"])  || `Unfortunately. ${bot["profileObj"]["name"]}'s profile could not be initialized. Please contact the system engineer for support.`} />}

                    <div ref={elementRef} />
                </Stack>
            </Grid>
        </Grid>
    </React.Fragment>)
}



export default HealthData